import { defineStore } from 'pinia';
import {
  login as userLogin,
  getUserInfo,
  LoginData,
  UserProfile,
} from '@/api/user';
import { setToken, clearToken } from '@/utils/auth';
import { removeRouteListener } from '@/utils/route-listener';
import { UserState } from './types';
import useAppStore from '../app';

const useUserStore = defineStore('user', {
  state: (): UserState => ({
    name: undefined,
    avatar: undefined,
    job: undefined,
    organization: undefined,
    location: undefined,
    email: undefined,
    introduction: undefined,
    personalWebsite: undefined,
    jobName: undefined,
    organizationName: undefined,
    locationName: undefined,
    phone: undefined,
    registrationDate: undefined,
    accountId: undefined,
    certification: undefined,
    role: '',
    nickname: undefined,
    roleName: undefined,
    merchantName: undefined,
    merchantId: undefined,
  }),

  getters: {
    userInfo(state: UserState): UserState {
      return { ...state };
    },
  },

  actions: {
    switchRoles() {
      return new Promise((resolve) => {
        this.role = this.role === 'user' ? 'admin' : 'user';
        resolve(this.role);
      });
    },
    // Set user's information
    setInfo(partial: Partial<UserState>) {
      this.$patch(partial);
    },

    // Reset user's information
    resetInfo() {
      this.$reset();
    },

    // Get user's information
    async info() {
      const res = await getUserInfo();
      const profile: UserProfile = res.data;

      // Map API response to UserState
      const roleValue =
        profile.roles && profile.roles.length > 0 ? profile.roles[0].value : '';
      const userState: Partial<UserState> = {
        name: profile.username,
        avatar: profile.avatar || undefined,
        email: profile.email || undefined,
        phone: profile.phone || undefined,
        role: (roleValue === 'admin' ||
        roleValue === 'user' ||
        roleValue === 'superAdmin' ||
        roleValue === '*'
          ? roleValue
          : '') as UserState['role'],
        organization: profile.merchant?.merchantName || undefined,
        registrationDate: profile.createdAt,
        accountId: profile.id?.toString() || undefined,
        nickname: profile.nickname || undefined,
        roleName:
          profile.roles && profile.roles.length > 0
            ? profile.roles[0].name
            : undefined,
        merchantName: profile.merchant?.merchantName || undefined,
        merchantId: profile.merchant?.id || undefined,
      };

      this.setInfo(userState);
    },

    // Login
    async login(loginForm: LoginData) {
      try {
        const res = await userLogin(loginForm);
        setToken(res.data.token);
      } catch (err) {
        clearToken();
        throw err;
      }
    },
    logoutCallBack() {
      const appStore = useAppStore();
      this.resetInfo();
      clearToken();
      removeRouteListener();
      appStore.clearServerMenu();
    },
    // Logout
    async logout() {
      // 不调用后端接口，直接执行退出逻辑，与本地环境保持一致
      this.logoutCallBack();
    },
  },
});

export default useUserStore;
